import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="signature"
export default class extends Controller {
  static targets = ['canvas']
  static values = {
    modalId: String,
    signUrl: String
  }

  init() {
    const canvasContext = this.canvasTarget.getContext('2d')
    canvasContext.clearRect(0, 0, 100000, 100000)

    const parentEl = this.canvasTarget.parentElement
    const parentElComputedStyle = getComputedStyle(parentEl)

    this.canvasTarget.width = parentEl.clientWidth -
      parseFloat(parentElComputedStyle.paddingLeft) -
      parseFloat(parentElComputedStyle.paddingRight) -
      2

    this.canvasTarget.height = Math.min(window.innerHeight - 225, 300)
  }

  async save() {
    const pngBlob = await new Promise((resolve, reject) => {
      this.canvasTarget.toBlob((blob) => {
        if (blob) {
          resolve(blob)
        } else {
          reject()
        }
      }, 'image/png')
    })

    const formData = new FormData()
    const f = new File([pngBlob], 'signature.png', { type: 'image/png' })
    formData.append("signature", f)

    $(document.getElementById(this.modalIdValue)).modal('hide')
    $.ajax({
      url: this.signUrlValue,
      headers: {
        Accept: 'application/javascript'
      },
      data: formData,
      processData: false,
      contentType: false,
      type: 'POST'
    })
  }

  onModalShown(e) {
    if (e.target.id !== this.modalIdValue) return

    this.init()
  }
}
